import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "./common/Button";
import { useMediaQuery } from "react-responsive";
import { SocialMedia } from "../types/socialMedia/socialMedia";
import SocialMediaRow from "./common/SocialMediaRow";
import { getScrollRefByKey, scrollToRef } from "../backend/scrollToRef";
import { getCaseList } from "../backend/services/caseCatergories";
import { getPatronatInfoByName } from "../backend/info/patronatInfo";
import formatPhoneNumber from "../utils/formatNumber";

const PhoneButton = ({ link, text }) => {
  return (
    <Button
      text={text}
      external_link={link}
      border="3px solid var(--white)"
      hoverBorder="3px solid var(--black)"
      textColor="var(--white)"
      hoverTextColor="var(--black)"
      fontWeight="bold"
      fontSize={"min(2.5rem, 9vw)"}
      padding="1rem 1rem"
      iconPath="/assets/icons/tel.svg"
      iconProps={{
        width: "min(2.5rem,10vw)",
        height: "min(2.5rem,10vw)",
        marginRight: "0.5rem",
      }}
      iconColor="var(--white)"
      hoverIconColor="var(--black)"
      marginBottom="2rem"
    />
  );
};

const ServiceMenu = ({ onClose }) => {
  const isMedium = useMediaQuery({ query: "(max-width: 600px)" });
  const isSmall = useMediaQuery({ query: "(max-width: 450px)" });

  const isFooterDouble = useMediaQuery({ query: `(max-width: 1100px)` });
  const navigate = useNavigate();
  const location = useLocation();
  const cases = getCaseList();

  return (
    <div style={styles.menuWrapper}>
      <div style={styles.menuContainer}>
        <div style={styles.navigationColumn}>
          <Button
            text={`ЗВЕРНУТИСЬ ДО СЛУЖБИ СУПРОВОДУ`}
            onClick={() => {
              onClose();
              window.scrollTo({
                top: document.documentElement.scrollHeight - (isFooterDouble ? 1700 : 1000),
                behavior: "smooth",
              });
            }}
            textColor="var(--white)"
            hoverTextColor="var(--black)"
            display="inline-flex"
            fontSize={isSmall ? "min(2rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
            fontWeight="normal"
            padding="1rem 0rem"
            fontFamily="UAFSans-Book"
            textAlign="start"
          />
          {cases.map((item) => (
            <Button
              text={item.name.toUpperCase()}
              onClick={() => {
                onClose();
                if (location.pathname === "/patronat") {
                  scrollToRef(getScrollRefByKey(item.navigationState), item.navigationState);
                } else navigate("/patronat", { state: { scrollTo: item.navigationState } });
              }}
              textColor="var(--white)"
              hoverTextColor="var(--black)"
              display="inline-flex"
              fontSize={isSmall ? "min(2rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
              fontWeight="normal"
              padding="1rem 0rem"
              fontFamily="UAFSans-Book"
              textAlign="start"
            />
          ))}
          <Button
            text="ПІДТРИМАТИ"
            external_link={getPatronatInfoByName("supportLink")}
            textColor="var(--black)"
            hoverTextColor="var(--white)"
            display="inline-flex"
            fontSize={isSmall ? "min(2rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
            fontWeight="normal"
            padding="1rem 0rem"
            marginBottom="0.5rem"
            fontFamily="UAFSans-Book"
          />
          {/* <Button
            text="ЗВІТ"
            onClick={() => {
              onClose();
              navigate("/anketa");
            }}
            textColor="var(--black)"
            hoverTextColor="var(--white)"
            display="inline-flex"
            fontSize={isSmall ? "min(2rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
            fontWeight="normal"
            padding="1rem 0rem"
            fontFamily="UAFSans-Book"
            marginBottom="0.5rem"
          /> */}
        </div>
        <PhoneButton
          link={formatPhoneNumber(getPatronatInfoByName("phone1"))}
          text={getPatronatInfoByName("phone1")}
        />
        <PhoneButton
          link={formatPhoneNumber(getPatronatInfoByName("phone2"))}
          text={getPatronatInfoByName("phone2")}
        />
        <a href={"mailto:" + getPatronatInfoByName("email")} style={styles.emailText}>
          {getPatronatInfoByName("email")}
        </a>
        <hr style={styles.divider} />

        <SocialMediaRow
          useMenu={true}
          rowStyle={{
            justifyContent: "space-between",
            gap: "2rem",
          }}
        />
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  menuWrapper: {
    position: "fixed",
    top: "var(--header-height)",
    left: 0,
    width: "100vw",
    height: "calc(100vh - var(--header-height))",
    zIndex: 1000,
    backgroundColor: "var(--olive)",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  menuContainer: {
    justifySelf: "center",
    alignSelf: "center",
    width: "var(--main-container-width)",
    padding: "3rem 0rem 7rem",
    margin: "0rem 1rem",
  },
  navigationColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
  divider: {
    width: "100%",
    borderColor: "var(--white)",
    margin: "2rem 0rem",
    backgroundBlendMode: "color",
  },
  contactColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginTop: "4rem",
  },
  contactTitle: {
    color: "var(--white)",
    fontSize: "1.125rem",
  },
  contactText: {
    color: "var(--white)",
    fontSize: "min(7vw, 2.5rem)",
    fontWeight: "bold",
    marginBottom: "2rem",
    textDecoration: "none",
  },
  emailText: {
    color: "var(--white)",
    fontSize: "min(7vw, 2.5rem)",
    fontWeight: "bold",
    marginBottom: "2rem",
    textDecoration: "none",
  },
};

export default ServiceMenu;
